import { getMatch, proceedHTTPRequest, startHTTPRequest, formatFinalData, deepClone } from "../../../assets/js/common";
import { CFG_MATCH_STORY_API, CFG_WIDGET_API_BASE } from "../../../assets/js/config";
import { SUCCESS_FETCH_ROI_DATA } from "../../types";

const setMiniContestsDataMutation = (state) => {
  let { allDataOfTheMatch } = state;

  let standingsData = formatFinalData(
      deepClone(allDataOfTheMatch)
  );
  let contests = (standingsData && standingsData[0] && standingsData[0].contests) || [];

  state.contest_count = allDataOfTheMatch.cc;
  state.selectedMatchContests = contests;
  return state;
};

const customTipsWidget = {
  namespaced: true,
  state: () => ({
    is_loading: true,
    module: null,
    hasMatchInfoData: false,
    matchStories: "",
    story_created_date: null,
    story_updated_date: null,
    allDataOfTheMatch: [],
    selectedMatchContests: [],
    contest_loaded: false,
    contest_count: 0,
  }),
  mutations: {
    [SUCCESS_FETCH_ROI_DATA]: (state, payload) => {
      if (typeof window === "undefined") {
          state.contest_loaded = false;
          state.allDataOfTheMatch = [];
      } else {
          state.allDataOfTheMatch = payload;
          state.contest_count = payload.cc;
          setMiniContestsDataMutation(state);
          state.contest_loaded = true;
      }
    }
  },
  actions: {
    fetchFeed: ({ state, rootState }) => {
      let { match_detail_store, route } = rootState;
      if (match_detail_store.no_matches_active) return;
      let match = getMatch(match_detail_store.match_data, "slug", match_detail_store.slug);
      if(!match) return;
      let match_code = match.code;
      let lang = route.path && route.path.includes("/hindi/") ? "hi/" : "";
      let storyMode = "ndtv";
      let storyUrl = CFG_MATCH_STORY_API.replace("{{mode}}", storyMode).replace("{{match_id}}", match_code).replace("{{lang}}", lang);
      state.is_loading = true;
      return proceedHTTPRequest({
        url: storyUrl,
        method: "get",
        can_append: false,
        add_headers: false,
      })
      .then((response) => {
        state.is_loading = false;
        state.matchStories = (response && response.html) || "";
        if(response.created_date) {
          state.story_created_date = response.created_date;
        }
        if(response.last_updated) {
          state.story_updated_date = response.last_updated;
        }
        if(state.matchStories) {
          state.hasMatchInfoData = true;
        }
      })
      .catch((e) => {
        state.is_loading = false;
        state.hasMatchInfoData = false;
        state.matchStories = "";
        state.story_created_date = null;
        state.story_updated_date = null;
      });      
    },
    resetFeed: ({ state }) => {
      state.matchStories = "";
      state.story_created_date = null;
      state.story_updated_date = null;
    },
    fetchMiniROIdata: ({ commit, rootState}) => {
      let { match_detail_store } = rootState;
      if (match_detail_store.no_matches_active) return;
      
      let match = getMatch(match_detail_store.match_data, "slug", match_detail_store.slug );
      let match_code = match.code;
      // let match_code = "qlsr03232021199427";

      return startHTTPRequest({
          method: "GET",
          url: `${CFG_WIDGET_API_BASE}api/App/ContestROI`,
          can_append: false,
          params: {
              match_code: `${match_code}_mini`
          },
        })
        .then((res) => {
          if (res) {
            let data = deepClone(res);
            commit(SUCCESS_FETCH_ROI_DATA, data);
          } else {
            console.log("API ERROR---->");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
export default customTipsWidget;
